
import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseComponent from '@/author/components/BaseComponent.vue';
import { EVENTS } from '@/author/constants';
import { generateHash } from '@/author/components/helper/hash';
import ModalStackChildren from '@/mixins/ModalStackChildren';
import { customTermsFilter } from '@/utils/customTermChecker';

type FlashcardTheme = {
  background?: string;
  color?: string;
};
@Component({methods: {customTermsFilter}})
export default class Flashcard extends Mixins(BaseComponent, ModalStackChildren) {
  @Prop() color!: string;
  @Prop() backgroundColor!: string;
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop() theme!: string;
  @Prop({ default: '' }) frontBackground!: string;
  @Prop({ default: '' }) backBackground!: string;
  @Prop({ default: '' }) frontColor!: string;
  @Prop({ default: '' }) backColor!: string;

  public $refs!: {
    flashcard: HTMLElement;
    back: HTMLElement;
  };

  created() {
    this.$parent?.$on('setup-modal', (hash: number) => {
      if (this.hash === hash) this.completed = true;
    });
  }

  computedTheme(side: string) {
    let theme: FlashcardTheme = {};
    if (side == 'front') {
      theme.background = this.frontBackground || this.backgroundColor;
      theme.color = this.frontColor || this.color;
    }
    if (side == 'back') {
      theme.background = this.backBackground || this.backgroundColor;
      theme.color = this.backColor || this.color;
    }
    if (this.theme === 'horizontal-accent') 
      return {
        backgroundColor: '#fff',
        color: this.backColor || this.color
      };
    
    return theme;
  }
  computedThemeAccent() {
    return {
      backgroundColor: this.backgroundColor,
      color: this.color
    };
  }
  flip() {
    this.completed = true;
    this.$parent?.$emit(EVENTS.COMPLETED, this.hash);
    this.$emit('modalcompleted');
    this.$refs.back?.focus();
  }
  public isCompleted(): boolean {
    return this.completed;
  }

  get hash(): number {
    return generateHash(
      this.title +
        this.description +
        this.theme +
        this.$refs.flashcard.innerHTML
    );
  }
}
